import { create } from 'zustand'
import { devtools, subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { StoreDevtoolsName } from '@stores/store-names.const'

import { registerWorkspaceStoreSubscriptions } from './subscriptions'
import { createWorkspaceActions } from './workspace.actions'
import { workspaceInitialState } from './workspace.slice'
import type { WorkspaceStore } from './workspace.type'

export const useWorkspaceStore = create<WorkspaceStore>()(
  devtools(
    subscribeWithSelector(
      immer((set) => ({
        ...workspaceInitialState,
        ...createWorkspaceActions(set),
      }))
    ),
    {
      name: StoreDevtoolsName.WorkspaceSettings,
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)

registerWorkspaceStoreSubscriptions(useWorkspaceStore)
